import _ from 'lodash';
import React, {FunctionComponent, ReactNode} from 'react';
import {ProductTypeIconMap} from '@treez-ui/core/icons';
import {Title} from '@treez-ui/core/layout';
import {TitleSize} from '@treez-ui/core/layout/Title';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import ProductGallery from '~/modules/widgets/PhotoGallery';

interface Props {
    actions?: ReactNode[];
    product: ProductInCatalog | Partial<ProductInCatalog>;
}

const ProductCard: FunctionComponent<Props> = (props: Props) => {
    const {actions, product = {} as Partial<ProductInCatalog>} = props;

    const {brandName, descriptions, images = [], name = '', type = ''} = product;

    const mainDescription = _.get(descriptions, 'main');

    const prouductTypeIcon = ProductTypeIconMap[type.toUpperCase()];

    return (
        <div className="product-card">
            <div className="product-info-container">
                <div className="images-container">
                    <ProductGallery images={images} />
                </div>
                <div className="product-details-container">
                    <div className="product-details">
                        <div className="high-level-details">
                            <div className="type">
                                {prouductTypeIcon}
                                <div> {type} </div>
                            </div>
                            <div className="brand-name">{brandName}</div>
                            <div className="display-name">
                                <Title text={name} size={TitleSize.LARGE} />
                            </div>
                        </div>
                        <div className="description">{mainDescription}</div>
                    </div>
                    <div className="call-to-action-container">{actions}</div>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
